"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const teletipo_normalizer_1 = __importDefault(require("../teletipo-normalizer"));
/**
 * normalizador del modulo MODULO_TELETIPO
 * @param {object} fields
 * @returns
 */
const teletiposNormalizer = (data, userCompatibilities, productCompatibilityGroup) => {
    try {
        const res = [];
        if (Array.isArray(data)) {
            let productAction;
            if (userCompatibilities && productCompatibilityGroup) {
                const productCompatibilities = userCompatibilities[productCompatibilityGroup];
                if (productCompatibilities) {
                    productAction = productCompatibilities.action;
                }
            }
            if (productAction) {
                data.forEach((teletipoItem) => {
                    var _a;
                    const { fields } = teletipoItem;
                    if (fields) {
                        const { action } = fields;
                        if (action === productAction) {
                            res.push((0, teletipo_normalizer_1.default)((_a = teletipoItem === null || teletipoItem === void 0 ? void 0 : teletipoItem.fields) === null || _a === void 0 ? void 0 : _a.TELETIPOLIST, userCompatibilities, productCompatibilityGroup));
                        }
                    }
                });
            }
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.default = teletiposNormalizer;
//# sourceMappingURL=index.js.map